<template>
  <iq-card>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-6">
          <b-button v-if="prevUrl" @click="$router.push(prevUrl)" variant="outline-danger">{{ prevNavTitle }}</b-button>
        </div>
        <div class="col-md-6 text-right">
          <b-button v-if="nextUrl" @click="$router.push(nextUrl)" variant="outline-success">{{ nextNavTitle }}</b-button>
        </div>
      </div>
    </template>
  </iq-card>
</template>
<script>
import { xray } from '../../../config/pluginInit'

export default {
  name: 'StepNavigation',
  mounted () {
    xray.index()
  },
  props: {
    currentStep: {
      type: String,
      default: 'CLAIM_ANALYSIS'
    },
    claimType: {
      type: String,
      default: 'CLAIM'
    }
  },
  computed: {
    idParam () {
      let ret = ''

      if (this.$route.params.id) {
        ret = `/${this.$route.params.id}`
      } else if (this.$route.query.id) {
        ret = `id=${this.$route.query.id}`
      }

      return ret
    },
    formIdParam () {
      let ret = ''

      ret = `formId=${this.$route.query.formId}`

      return ret
    },
    prevUrl () {
      if (this.currentStep === 'CLAIM_ANALYSIS') {
        return '/mi/list-initial'
      }

      const stepIndex = this.handleGetStepIndex()
      const prevStep = this.steps.filter(e => e.claimType.includes(this.claimType))[stepIndex - 1]

      if (prevStep) {
        // return `${prevStep.url}${this.idParam}${this.formIdParam}`
        return `${prevStep.url}${this.formIdParam}`
      }

      return '/mi/list-initial'
    },
    prevNavTitle () {
      if (this.currentStep === 'CLAIM_ANALYSIS') {
        return 'Back'
      }

      const stepIndex = this.handleGetStepIndex()
      const prevStep = this.steps.filter(e => e.claimType.includes(this.claimType))[stepIndex - 1]

      if (prevStep) {
        return `Back to ${prevStep.title}`
      }

      return 'Back'
    },
    nextUrl () {
      const stepIndex = this.handleGetStepIndex()
      const nextStep = this.steps.filter(e => e.claimType.includes(this.claimType))[stepIndex + 1]

      if (nextStep) {
        // return `${nextStep.url}${this.idParam}${this.formIdParam}`
        return `${nextStep.url}${this.formIdParam}`
      }

      return ''
    },
    nextNavTitle () {
      const stepIndex = this.handleGetStepIndex()
      const nextStep = this.steps.filter(e => e.claimType.includes(this.claimType))[stepIndex + 1]

      if (nextStep) {
        return `Go to ${nextStep.title}`
      }

      return 'Go'
    }
  },
  methods: {
    handleGetStepIndex () {
      return this.steps.filter(e => e.claimType.includes(this.claimType)).map(e => e.key).indexOf(this.currentStep)
    }
  },
  data () {
    return {
      steps: [
        {
          key: 'CLAIM_ANALYSIS',
          title: 'Claim Analysis',
          url: '/mi/claim-analysis?',
          claimType: ['CLAIM']
        },
        {
          key: 'COST_BREAKDOWN',
          title: 'Cost Breakdown',
          url: '/mi/cost-breakdown?',
          claimType: ['CLAIM']
        },
        {
          key: 'LOST_RATIO',
          title: 'Loss Ratio',
          url: '/mi/loss-ratio-input?',
          claimType: ['CLAIM']
        },
        {
          key: 'MANAGEMENT_APPROVAL',
          title: 'Management Approval',
          url: '/mi/management-approval?',
          claimType: ['CLAIM']
        },
        {
          key: 'LIST_RCA',
          title: 'List RCA',
          url: '/mi/root-cause-analysis?',
          claimType: ['CLAIM']
        },
        {
          key: 'RCA_FINAL',
          title: 'RCA Final',
          url: '/mi/final-report-root-cause-analysis?',
          claimType: ['CLAIM']
        },
        {
          key: 'MONITORING',
          title: 'Monitoring',
          url: '/mi/monitoring-form?',
          claimType: ['CLAIM']
        },
        {
          key: 'RECOMMENDATION',
          title: 'Recommendation',
          url: '/mi/add-form-recommendation?',
          claimType: ['NON_CLAIM', 'CLAIM']
        },
        {
          key: 'EVALUATION',
          title: 'Evaluation',
          url: '/mi/add-form-evaluation?',
          claimType: ['NON_CLAIM', 'CLAIM']
        },
        {
          key: 'ERM',
          title: 'Enterprise Risk Management',
          url: '/mi/enterprise-risk-management?',
          claimType: ['NON_CLAIM', 'CLAIM']
        },
        {
          key: 'MANAGEMENT_SUMMARY',
          title: 'Management Summary',
          url: '/mi/management-summary?',
          claimType: ['CLAIM']
        }
      ]
    }
  }
}
</script>
